export interface DMARegion {
  id: string;
  name: string;
  code: string;
}

// Official Nielsen DMA List - 210 Designated Market Areas.
// Source of truth: frontend/src/data/nielsen-mkt-map.json (dma_code/dma_name),
// the same canonical Nielsen reference that feeds the DMA choropleth boundaries.
// Reconciled with that source in CTV-500 to fix corrupted code→name pairings
// (e.g. code 553 is Marquette, MI — not "Elmira (Corning)"). Names are verbatim
// from the Nielsen reference; `id` mirrors `code`. Lookups are by code/id only.
// Keep this file in sync between frontend/ and apps/selfservice/ (shared copies).
export const DMA_REGIONS: DMARegion[] = [
  { id: '501', name: 'New York, NY', code: '501' },
  { id: '803', name: 'Los Angeles, CA', code: '803' },
  { id: '602', name: 'Chicago, IL', code: '602' },
  { id: '504', name: 'Philadelphia, PA', code: '504' },
  { id: '623', name: 'Dallas-Ft. Worth, TX', code: '623' },
  { id: '511', name: 'Washington, DC (Hagerstown, MD)', code: '511' },
  { id: '618', name: 'Houston, TX', code: '618' },
  { id: '807', name: 'San Francisco-Oakland-San Jose, CA', code: '807' },
  { id: '506', name: 'Boston, MA (Manchester, NH)', code: '506' },
  { id: '524', name: 'Atlanta, GA', code: '524' },
  { id: '539', name: 'Tampa-St. Petersburg (Sarasota), FL', code: '539' },
  { id: '753', name: 'Phoenix, AZ', code: '753' },
  { id: '819', name: 'Seattle-Tacoma, WA', code: '819' },
  { id: '505', name: 'Detroit, MI', code: '505' },
  { id: '613', name: 'Minneapolis-St. Paul, MN', code: '613' },
  { id: '528', name: 'Miami-Fort Lauderdale, FL', code: '528' },
  { id: '751', name: 'Denver, CO', code: '751' },
  { id: '534', name: 'Orlando-Daytona Beach-Melbourne, FL', code: '534' },
  { id: '510', name: 'Cleveland-Akron (Canton), OH', code: '510' },
  { id: '862', name: 'Sacramento-Stockton-Modesto, CA', code: '862' },
  { id: '609', name: 'St. Louis, MO', code: '609' },
  { id: '821', name: 'Bend, OR', code: '821' },
  { id: '517', name: 'Charlotte, NC', code: '517' },
  { id: '508', name: 'Pittsburgh, PA', code: '508' },
  { id: '560', name: 'Raleigh-Durham (Fayetteville), NC', code: '560' },
  { id: '512', name: 'Baltimore, MD', code: '512' },
  { id: '659', name: 'Nashville, TN', code: '659' },
  { id: '527', name: 'Indianapolis, IN', code: '527' },
  { id: '825', name: 'San Diego, CA', code: '825' },
  { id: '770', name: 'Salt Lake City, UT', code: '770' },
  { id: '641', name: 'San Antonio, TX', code: '641' },
  { id: '616', name: 'Kansas City, MO', code: '616' },
  { id: '533', name: 'Hartford & New Haven, CT', code: '533' },
  { id: '535', name: 'Columbus, OH', code: '535' },
  { id: '515', name: 'Cincinnati, OH', code: '515' },
  { id: '617', name: 'Milwaukee, WI', code: '617' },
  { id: '531', name: 'Tri-Cities, TN-VA', code: '531' },
  { id: '567', name: 'Greenville-Spartanburg, SC-Asheville, NC-Anderson,SC', code: '567' },
  { id: '839', name: 'Las Vegas, NV', code: '839' },
  { id: '635', name: 'Austin, TX', code: '635' },
  { id: '566', name: 'Harrisburg-Lancaster-Lebanon-York, PA', code: '566' },
  { id: '561', name: 'Jacksonville, FL', code: '561' },
  { id: '630', name: 'Birmingham (Anniston and Tuscaloosa), AL', code: '630' },
  { id: '544', name: 'Norfolk-Portsmouth-Newport News, VA', code: '544' },
  { id: '650', name: 'Oklahoma City, OK', code: '650' },
  { id: '518', name: 'Greensboro-High Point-Winston Salem, NC', code: '518' },
  { id: '790', name: 'Albuquerque-Santa Fe, NM', code: '790' },
  { id: '529', name: 'Louisville, KY', code: '529' },
  { id: '563', name: 'Grand Rapids-Kalamazoo-Battle Creek, MI', code: '563' },
  { id: '622', name: 'New Orleans, LA', code: '622' },
  { id: '640', name: 'Memphis, TN', code: '640' },
  { id: '514', name: 'Buffalo, NY', code: '514' },
  { id: '521', name: 'Providence, RI-New Bedford, MA', code: '521' },
  { id: '866', name: 'Fresno-Visalia, CA', code: '866' },
  { id: '571', name: 'Ft. Myers-Naples, FL', code: '571' },
  { id: '556', name: 'Richmond-Petersburg, VA', code: '556' },
  { id: '693', name: 'Little Rock-Pine Bluff, AR', code: '693' },
  { id: '686', name: 'Mobile, AL-Pensacola (Ft. Walton Beach), FL', code: '686' },
  { id: '532', name: 'Albany-Schenectady-Troy, NY', code: '532' },
  { id: '557', name: 'Knoxville, TN', code: '557' },
  { id: '671', name: 'Tulsa, OK', code: '671' },
  { id: '577', name: 'Wilkes Barre-Scranton, PA', code: '577' },
  { id: '541', name: 'Lexington, KY', code: '541' },
  { id: '542', name: 'Dayton, OH', code: '542' },
  { id: '513', name: 'Flint-Saginaw-Bay City, MI', code: '513' },
  { id: '743', name: 'Anchorage, AK', code: '743' },
  { id: '658', name: 'Green Bay-Appleton, WI', code: '658' },
  { id: '573', name: 'Roanoke-Lynchburg, VA', code: '573' },
  { id: '652', name: 'Omaha, NE', code: '652' },
  { id: '564', name: 'Charleston-Huntington, WV', code: '564' },
  { id: '530', name: 'Tallahassee, FL-Thomasville, GA', code: '530' },
  { id: '619', name: 'Springfield, MO', code: '619' },
  { id: '789', name: 'Tucson (Sierra Vista), AZ', code: '789' },
  { id: '546', name: 'Columbia, SC', code: '546' },
  { id: '679', name: 'Des Moines-Ames, IA', code: '679' },
  { id: '678', name: 'Wichita-Hutchinson, KS Plus', code: '678' },
  { id: '881', name: 'Spokane, WA', code: '881' },
  { id: '636', name: 'Harlingen-Weslaco-Brownsville-McAllen, TX', code: '636' },
  { id: '691', name: 'Huntsville-Decatur (Florence), AL', code: '691' },
  { id: '538', name: 'Rochester, NY', code: '538' },
  { id: '555', name: 'Syracuse, NY', code: '555' },
  { id: '648', name: 'Champaign & Springfield-Decatur, IL', code: '648' },
  { id: '575', name: 'Chattanooga, TN', code: '575' },
  { id: '500', name: 'Portland-Auburn, ME', code: '500' },
  { id: '765', name: 'El Paso, TX', code: '765' },
  { id: '669', name: 'Madison, WI', code: '669' },
  { id: '637', name: 'Cedar Rapids-Waterloo-Iowa City & Dubuque, IA', code: '637' },
  { id: '632', name: 'Paducah, KY-Cape Girardeau, MO-Harrisburg, IL', code: '632' },
  { id: '625', name: 'Waco-Temple-Bryan, TX', code: '625' },
  { id: '612', name: 'Shreveport, LA', code: '612' },
  { id: '752', name: 'Colorado Springs-Pueblo, CO', code: '752' },
  { id: '718', name: 'Jackson, MS', code: '718' },
  { id: '507', name: 'Savannah, GA', code: '507' },
  { id: '519', name: 'Charleston, SC', code: '519' },
  { id: '570', name: 'Myrtle Beach-Florence, SC', code: '570' },
  { id: '523', name: 'Burlington, VT-Plattsburgh, NY', code: '523' },
  { id: '716', name: 'Baton Rouge, LA', code: '716' },
  { id: '682', name: 'Davenport, IA-Rock Island-Moline, IL', code: '682' },
  { id: '588', name: 'South Bend-Elkhart, IN', code: '588' },
  { id: '757', name: 'Boise, ID', code: '757' },
  { id: '649', name: 'Evansville, IN', code: '649' },
  { id: '661', name: 'San Angelo, TX', code: '661' },
  { id: '509', name: 'Ft. Wayne, IN', code: '509' },
  { id: '520', name: 'Augusta, GA', code: '520' },
  { id: '627', name: 'Wichita Falls, TX-Lawton, OK', code: '627' },
  { id: '545', name: 'Greenville-New Bern-Washington, NC', code: '545' },
  { id: '543', name: 'Springfield-Holyoke, MA', code: '543' },
  { id: '811', name: 'Reno, NV', code: '811' },
  { id: '551', name: 'Lansing, MI', code: '551' },
  { id: '722', name: 'Lincoln & Hastings-Kearney, NE', code: '722' },
  { id: '633', name: 'Odessa-Midland, TX', code: '633' },
  { id: '675', name: 'Peoria-Bloomington, IL', code: '675' },
  { id: '709', name: 'Tyler-Longview(Lufkin & Nacogdoches), TX', code: '709' },
  { id: '725', name: 'Sioux Falls (Mitchell), SD', code: '725' },
  { id: '698', name: 'Montgomery-Selma, AL', code: '698' },
  { id: '724', name: 'Fargo-Valley City, ND', code: '724' },
  { id: '503', name: 'Macon, GA', code: '503' },
  { id: '828', name: 'Monterey-Salinas, CA', code: '828' },
  { id: '540', name: 'Traverse City-Cadillac, MI', code: '540' },
  { id: '582', name: 'Lafayette, IN', code: '582' },
  { id: '801', name: 'Eugene, OR', code: '801' },
  { id: '855', name: 'Santa Barbara-Santa Maria-San Luis Obispo, CA', code: '855' },
  { id: '536', name: 'Youngstown, OH', code: '536' },
  { id: '522', name: 'Columbus, GA', code: '522' },
  { id: '600', name: 'Corpus Christi, TX', code: '600' },
  { id: '550', name: 'Wilmington, NC', code: '550' },
  { id: '702', name: 'La Crosse-Eau Claire, WI', code: '702' },
  { id: '634', name: 'Amarillo, TX', code: '634' },
  { id: '868', name: 'Chico-Redding, CA', code: '868' },
  { id: '673', name: 'Columbus-Tupelo-West Point, MS', code: '673' },
  { id: '705', name: 'Wausau-Rhinelander, WI', code: '705' },
  { id: '813', name: 'Medford-Klamath Falls, OR', code: '813' },
  { id: '604', name: 'Columbia-Jefferson City, MO', code: '604' },
  { id: '628', name: 'Monroe, LA-El Dorado, AR', code: '628' },
  { id: '576', name: 'Salisbury, MD', code: '576' },
  { id: '610', name: 'Rockford, IL', code: '610' },
  { id: '692', name: 'Beaumont-Port Arthur, TX', code: '692' },
  { id: '605', name: 'Topeka, KS', code: '605' },
  { id: '651', name: 'Lubbock, TX', code: '651' },
  { id: '676', name: 'Duluth, MN-Superior, WI', code: '676' },
  { id: '804', name: 'Palm Springs, CA', code: '804' },
  { id: '687', name: 'Minot-Bismarck-Dickinson(Williston), ND', code: '687' },
  { id: '744', name: 'Honolulu, HI', code: '744' },
  { id: '624', name: 'Sioux City, IA', code: '624' },
  { id: '656', name: 'Panama City, FL', code: '656' },
  { id: '516', name: 'Erie, PA', code: '516' },
  { id: '525', name: 'Albany, GA', code: '525' },
  { id: '603', name: 'Joplin, MO-Pittsburg, KS', code: '603' },
  { id: '611', name: 'Rochester, MN-Mason City, IA-Austin, MN', code: '611' },
  { id: '537', name: 'Bangor, ME', code: '537' },
  { id: '746', name: 'Biloxi-Gulfport, MS', code: '746' },
  { id: '592', name: 'Gainesville, FL', code: '592' },
  { id: '581', name: 'Terre Haute, IN', code: '581' },
  { id: '657', name: 'Sherman, TX-Ada, OK', code: '657' },
  { id: '502', name: 'Binghamton, NY', code: '502' },
  { id: '758', name: 'Idaho Falls-Pocatello, ID', code: '758' },
  { id: '554', name: 'Wheeling, WV-Steubenville, OH', code: '554' },
  { id: '559', name: 'Bluefield-Beckley-Oak Hill, WV', code: '559' },
  { id: '762', name: 'Missoula, MT', code: '762' },
  { id: '662', name: 'Abilene-Sweetwater, TX', code: '662' },
  { id: '771', name: 'Yuma, AZ-El Centro, CA', code: '771' },
  { id: '756', name: 'Billings, MT', code: '756' },
  { id: '710', name: 'Hattiesburg-Laurel, MS', code: '710' },
  { id: '565', name: 'Elmira, NY', code: '565' },
  { id: '558', name: 'Lima, OH', code: '558' },
  { id: '755', name: 'Great Falls, MT', code: '755' },
  { id: '643', name: 'Lake Charles, LA', code: '643' },
  { id: '606', name: 'Dothan, AL', code: '606' },
  { id: '717', name: 'Quincy, IL-Hannibal, MO-Keokuk, IA', code: '717' },
  { id: '569', name: 'Harrisonburg, VA', code: '569' },
  { id: '553', name: 'Marquette, MI', code: '553' },
  { id: '639', name: 'Jackson, TN', code: '639' },
  { id: '549', name: 'Watertown, NY', code: '549' },
  { id: '644', name: 'Alexandria, LA', code: '644' },
  { id: '734', name: 'Jonesboro, AR', code: '734' },
  { id: '736', name: 'Bowling Green, KY', code: '736' },
  { id: '584', name: 'Charlottesville, VA', code: '584' },
  { id: '574', name: 'Johnstown-Altoona, PA', code: '574' },
  { id: '749', name: 'Laredo, TX', code: '749' },
  { id: '759', name: 'Cheyenne, WY-Scottsbluff, NE', code: '759' },
  { id: '820', name: 'Portland, OR', code: '820' },
  { id: '773', name: 'Grand Junction-Montrose, CO', code: '773' },
  { id: '642', name: 'Lafayette, LA', code: '642' },
  { id: '760', name: 'Twin Falls, ID', code: '760' },
  { id: '711', name: 'Meridian, MS', code: '711' },
  { id: '754', name: 'Butte-Bozeman, MT', code: '754' },
  { id: '647', name: 'Greenwood-Greenville, MS', code: '647' },
  { id: '597', name: 'Parkersburg, WV', code: '597' },
  { id: '802', name: 'Eureka, CA', code: '802' },
  { id: '767', name: 'Casper-Riverton, WY', code: '767' },
  { id: '737', name: 'Mankato, MN', code: '737' },
  { id: '631', name: 'Ottumwa, IA-Kirksville, MO', code: '631' },
  { id: '638', name: 'St. Joseph, MO', code: '638' },
  { id: '745', name: 'Fairbanks, AK', code: '745' },
  { id: '626', name: 'Victoria, TX', code: '626' },
  { id: '596', name: 'Zanesville, OH', code: '596' },
  { id: '766', name: 'Helena, MT', code: '766' },
  { id: '552', name: 'Presque Isle, ME', code: '552' },
  { id: '747', name: 'Alaska', code: '747' },
  { id: '583', name: 'Alpena, MI', code: '583' },
  { id: '740', name: 'North Platte, NE', code: '740' },
  { id: '798', name: 'Glendive, MT', code: '798' },
  { id: '800', name: 'Bakersfield, CA', code: '800' },
  { id: '598', name: 'Clarksburg-Weston, WV', code: '598' },
  { id: '670', name: 'Ft. Smith-Fayetteville-Springdale-Rogers, AR', code: '670' },
  { id: '764', name: 'Rapid City, SD', code: '764' },
  { id: '547', name: 'Toledo, OH', code: '547' },
  { id: '526', name: 'Utica, NY', code: '526' },
  { id: '548', name: 'West Palm Beach-Ft. Pierce, FL', code: '548' },
  { id: '810', name: 'Yakima-Pasco-Richland-Kennewick, WA', code: '810' },
];
